import {header} from "./elements.js";
import {getElement} from "./helpers.js";



const burger = () => {

    const navigation = header.querySelector("nav");
    const burger = header.querySelector(".burger");
    if (!burger) return;
    burger.addEventListener("click", toggleMenu);
    navigation.querySelector('.btn-close').addEventListener("click", toggleMenu);


    function toggleMenu() {
        burger.classList.toggle("active");
        // navigation.classList.toggle("active");
        // if (!getElement('.navigation__menu').classList.contains('active'))getElement('.navigation__menu').classList.add('active')
        navigation.classList.toggle("active");
        header.classList.toggle('active');
        setTimeout(()=>{
            document.body.classList.toggle("no-touch");
            document.body.classList.toggle("active");
        }, 100)

        if (getElement('.user-navigation__btn') && getElement('.user-navigation__btn').classList.contains('active')) {
            getElement('.user-navigation__btn').classList.toggle('active');
            getElement('.user-navigation__btn').nextElementSibling.classList.toggle('active')
        }
    }
};
export default burger;
